import "core-js/modules/es.array.push.js";
import { modal } from '@/share/components';
import { api } from '@/server';
import URLS from '@/server/urls';
import { useAuthorStore } from '@/stores';
import { useRouter } from 'vue-router';
export const useProjAppraise = () => {
  const router = useRouter();
  const {
    runAsync: getProjAppraiseIdApi
  } = fetchApi(api.kpi.projAppraise.getId, {
    showError: false
  });
  const authorStore = useAuthorStore();
  const {
    runAsync: removeProjAppraiseApi
  } = fetchApi(api.kpi.projAppraise.remove, {
    showError: false
  });

  // openProjAppraiseScoring 打开自评表评分页面
  const openProjAppraiseScoring = async (projId, m = 'view') => {
    const {
      error,
      id
    } = await getProjAppraiseIdApi({
      projId
    });
    if (error) {
      await modal.alert.error('打开自评表', error);
      return false;
    }
    await router.push({
      path: `/kpi/proj-kpi/appraise/scoring-detail/${id}`,
      query: {
        m
      }
    });
    return true;
  };

  //  打开自评表权重设置页面
  const openProjAppraiseWeightSetting = async (projId, m = 'view') => {
    const {
      error,
      id
    } = await getProjAppraiseIdApi({
      projId
    });
    if (error) {
      await modal.alert.error('打开自评表', error);
      return false;
    }
    await router.push({
      path: `/kpi/proj-kpi/appraise/weight-setting-detail/${id}`,
      query: {
        m
      }
    });
    return true;
  };
  const removeProjAppraise = async id => {
    const {
      error
    } = await removeProjAppraiseApi({
      id
    });
    if (error) {
      modal.notification.error('删除自评表失败', '删除自评表').catch();
      return false;
    }
    return true;
  };
  const openProjAppraiseExcel = async (id, types) => {
    let xlsUrl = URLS.kpi.projAppraise.xls;
    if (!xlsUrl.endsWith('/')) {
      xlsUrl = xlsUrl + '/';
    }
    if (!types) {
      types = 'score';
    }
    xlsUrl = xlsUrl + id + `?t=${types}&access-token=${authorStore.token}`;
    try {
      window.open(xlsUrl, '_blank');
    } catch (err) {
      console.log(err);
    }
  };
  const openProjAppraiseExcelByProjId = async (projId, types) => {
    const {
      error,
      id
    } = await getProjAppraiseIdApi({
      projId
    });
    if (error) {
      await modal.alert.error('打开自评表出错', error);
      return false;
    }
    await openProjAppraiseExcel(id, types);
  };
  return {
    openProjAppraiseScoring,
    openProjAppraiseWeightSetting,
    removeProjAppraise,
    openProjAppraiseExcel,
    openProjAppraiseExcelByProjId
  };
};